import { Skeleton } from '@/components/sui/skeleton'

export function NotificationItemSkeleton() {
  return (
    <div className="px-4 py-2.5">
      <div className="flex items-start gap-3">
        <Skeleton className="h-9 w-9 shrink-0 rounded-full" />
        <div className="min-w-0 flex-1 space-y-1.5">
          <div className="flex items-start justify-between gap-2">
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-3 w-10" />
          </div>
          <div className="flex items-center gap-1">
            <Skeleton className="h-3 w-20 shrink-0" />
            <Skeleton className="size-4 shrink-0 rounded-full" />
            <Skeleton className="h-3 w-28" />
          </div>
        </div>
      </div>
    </div>
  )
}

interface NotificationsPanelSkeletonProps {
  rowCount?: number
}

export function NotificationsPanelSkeleton({
  rowCount = 5,
}: NotificationsPanelSkeletonProps) {
  return (
    <div className="pt-2 pb-2">
      {Array.from({ length: rowCount }).map((_, i) => (
        <NotificationItemSkeleton key={i} />
      ))}
    </div>
  )
}
